import { ComplexFlowLayout } from '../complex-flow-layout';

export const RightFlowContainer = ({ handleOnDrop }: any) => {
	return (
		<div className="OnboardingFlow--right" style={{ width: '80%' }}>
			<ComplexFlowLayout handleOnDrop={handleOnDrop} />
		</div>
	);
};
